// extracted by mini-css-extract-plugin
export default {"role":"profile_role__w2Xot"};